import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

// Importação do Router
import { Link, Redirect} from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

class RecuperarSenha extends Component {
   // Handlers de form
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      email: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.recuperar_senha = this.recuperar_senha.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  recuperar_senha(event) {
    var self = this;
    event.preventDefault();
    var headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    };
    var datasave = {
      email: this.state.email,
    };
    this.handleAlert('', '', 'open');
    fetch(config.get('api') + '/usuario/recuperar-senha', { method: 'POST', mode: 'cors', headers: headers, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
      self.refs.request_api.validate(responseJson, 'alert');
      if (responseJson.status === 'success') {
        var url = '/';
        var storage = {
          alert_message: responseJson.message,
          alert_type: responseJson.status,
        };
        localStorage.setItem("verify_message", JSON.stringify(storage));
        self.setState({redirect_url: url});
      } else {
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }
       }).catch((error) => {
      console.error(error);
    });
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="user-wrapper hidden-xs hidden-sm hidden-md" style={{backgroundImage: "url('" + config.get('cdn') + "/images/modal_background.png'), url('" + config.get('cdn') + "/images/fundo-login.jpg')"}}>
    <div className="user-wrapper" style={{backgroundImage: "url('" + config.get('cdn') + "/images/modal_background.png'), url('" + config.get('cdn') + "/images/fundo-login.jpg')"}}>
      <div className="user-layer">
        <div className="container">
          <div className="row">
            <div className="col-md-4 col-md-offset-4">
              <div className="user-content text-center">
                <img src={config.get('cdn') + '/images/logo2.png'} alt="SIGTRIP" />
                <form onSubmit={this.recuperar_senha}>
                  <div className="row">
                    <div className="col-md-10 col-md-offset-1 form-group">
                      <div className="input-group">
                        <div className="input-group-addon"><i className="fa fa-fw fa-at"></i></div>
                        <input type="email" name="email" className="form-control" placeholder="Seu e-mail" value={this.state.email} onChange={this.handleChange.bind(this, 'email')} />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-10 col-md-offset-1">
                      <button className="btn btn-success btn-block btn-lg" type="submit"><i className="fa fa-fw fa-lock"></i> Recuperar senha</button>
                    </div>
                  </div>
                </form>
                <p className="text-right"><Link to={'/usuario/login'} className="link-recuperar-senha">Voltar para login</Link></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="user-wrapper visible-xs-block visible-sm-block visible-md-block" style={{backgroundImage: "url('" + config.get('cdn') + "/images/modal_background.png')"}}>
    <div className="user-wrapper" style={{backgroundImage: "url('" + config.get('cdn') + "/images/modal_background.png')"}}>
      <div className="user-layer">
        <div className="container">
          <div className="row">
            <div className="col-md-4 col-md-offset-4">
              <div className="user-content text-center">
                <img src={config.get('cdn') + '/images/logo2.png'} alt="SIGTRIP" />
                <form onSubmit={this.recuperar_senha}>
                  <div className="row">
                    <div className="col-md-10 col-md-offset-1 form-group">
                      <div className="input-group">
                        <div className="input-group-addon"><i className="fa fa-fw fa-at"></i></div>
                        <input type="email" name="email" className="form-control" placeholder="Seu e-mail" value={this.state.email} onChange={this.handleChange.bind(this, 'email')} />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-10 col-md-offset-1">
                      <button className="btn btn-success btn-block btn-lg" type="submit"><i className="fa fa-fw fa-lock"></i> Recuperar senha</button>
                    </div>
                  </div>
                </form>
                <p className="text-right"><Link to={'/usuario/login'} className="link-recuperar-senha">Voltar para login</Link></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</div>
    );
  }
}

export default RecuperarSenha;



// WEBPACK FOOTER //
// ./src/Components/Users/RecuperarSenha.js